export enum PrizeCategories {
  PRIZE_CATEGORY_1 = 'Best Beginner Hack',
  PRIZE_CATEGORY_2 = 'Best Design',
  PRIZE_CATEGORY_3 = 'Chaotic Evil',
  PRIZE_CATEGORY_4 = 'Best Use of AI or AI Agents',
}

export default PrizeCategories;
